var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99979 0.359375C4.22709 0.359375 0.358887 4.22758 0.358887 8.99938C0.358769 10.1341 0.582191 11.2578 1.0164 12.3062C1.4506 13.3547 2.08708 14.3073 2.88948 15.1097C3.69189 15.9121 4.6445 16.5486 5.69292 16.9828C6.74133 17.417 7.86501 17.6404 8.99979 17.6403C13.7707 17.6403 17.6398 13.7721 17.6398 8.99938C17.6398 4.22758 13.7707 0.359375 8.99979 0.359375ZM9.80619 3.47878C10.6486 3.47878 10.8961 3.96748 10.8961 4.52638C10.8961 5.22388 10.3381 5.86917 9.38499 5.86917C8.58759 5.86917 8.20779 5.46868 8.23119 4.80538C8.23119 4.24648 8.69829 3.47878 9.80619 3.47878ZM7.64799 14.1744C7.07199 14.1744 6.65169 13.8243 7.05399 12.2898L7.71369 9.56728C7.82799 9.13168 7.84689 8.95708 7.71369 8.95708C7.54179 8.95708 6.79389 9.25768 6.35289 9.55468L6.06579 9.08398C7.46529 7.91488 9.07449 7.22907 9.76299 7.22907C10.339 7.22907 10.4344 7.90948 10.1473 8.95708L9.39129 11.8191C9.25719 12.3249 9.31479 12.4995 9.44889 12.4995C9.62169 12.4995 10.1869 12.2907 10.7431 11.8524L11.0689 12.2898C9.70719 13.6506 8.22309 14.1744 7.64799 14.1744Z",
    fill: "#D0004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfo);
export default __webpack_public_path__ + "static/media/red-info.b9fd5cb24fb127f2b97590f60535d2bf.svg";
export { ForwardRef as ReactComponent };